import React from 'react';

const ProductRecommendations: React.FC = () => {
  const products = [
    {
      id: 1,
      name: '小苍娃汆味呛鼻子登封小苍娃芥丝辣疙瘩丝介菜开胃咸菜下饭菜河南味道 500克芥丝3袋共3斤',
      price: '25.4',
      originalPrice: '38.8',
      image: '/images/jiecaisi.jpg',
      sales: 1234
    },
    {
      id: 2,
      name: '雅朴善太室本草黄精茶 道地养生茶 养生茶一盒',
      price: '199',
      originalPrice: '599.00',
      image: '/images/huangjingcha.jpg',
      sales: 856
    },
    {
      id: 3,
      name: '张弓大汉盛运 浓香型白酒 52度 500ml*6瓶 整箱装',
      price: '910',
      originalPrice: '980',
      image: '/images/zhanggongjiu.jpg',
      sales: 567
    },
    {
      id: 4,
      name: '鲲满坊贵州茅台镇 酱香型白酒 坤沙高粱酒整箱纯粮食53度品鉴酒 53度 500mL 6瓶 坤沙鉴赏酒',
      price: '586',
      originalPrice: '698',
      image: '/images/kunmanfang.jpg',
      sales: 432
    }
  ];

  return (
    <div className="bg-white mb-6 p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold text-gray-800">热门推荐</h2>
        <button className="text-primary text-sm hover:text-blue-700 transition-colors">查看更多</button>
      </div>
      
      <div className="grid grid-cols-2 gap-6">
        {products.map((product) => (
          <div key={product.id} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
            <div className="w-full h-36 bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
              <img src={product.image} alt={product.name} className="w-full h-full object-cover" />
            </div>
            <div className="p-5">
              <h3 className="font-semibold text-gray-800 text-base mb-4 line-clamp-2 leading-tight">
                {product.name}
              </h3>
              <div className="flex items-center space-x-3 mb-4">
                <span className="text-2xl font-bold text-red-600">¥{product.price}</span>
                <span className="text-gray-400 text-base line-through">¥{product.originalPrice}</span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-gray-500 text-sm">已售 {product.sales}</span>
                <button className="bg-primary text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-blue-600 transition-colors">
                  立即购买
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductRecommendations;
